import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import Image from "../assets/images/1.png";
import Mobilelogo from "../assets/images/mobileLogo.png";
import Footer from "./footer";
import { IoMenu, IoClose } from "react-icons/io5";

const PrivacyPolicy = () => {
  const sidebarRef = useRef(null);
  const headerRef = useRef(null);
  const [showSidebar, setShowSidebar] = useState(false);
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= 768); // Initialize based on window width
  const [currentLogo, setCurrentLogo] = useState(
    window.innerWidth <= 500 ? Mobilelogo : Image // Initialize logo based on screen size
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setShowSidebar(false);
      }
    };

    if (showSidebar) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showSidebar]);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsLargeScreen(width >= 768);
      setCurrentLogo(width <= 500 && width >= 200 ? Mobilelogo : Image);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <div className="px-8 lg:px-32 xl:px-52 bg-white overflow-x-hidden">
        <header
          ref={headerRef}
          className={`text-black z-10 bg-white ${
            isLargeScreen ? "" : "fixed top-0 left-0 right-0 w-full"
          }`}
          style={{ width: "100%" }}
        >
          <div className="container mx-auto flex items-center justify-between h-[80px]">
            <div className="flex items-center justify-center mb-2">
              <Link to="/">
                <img
                  src={currentLogo}
                  alt="Icon"
                  className={`object-cover w-[150px] cursor-pointer ${
                    currentLogo === Mobilelogo
                      ? "w-[165px] h-auto "
                      : "w-[170px] h-auto mt-1"
                  }`}
                />
              </Link>
            </div>

            {/* Mobile Menu Icon (Inline with logo) */}
            {!isLargeScreen && (
              <div className="flex items-center absolute top-0 right-0 p-4 z-10">
                <button onClick={() => setShowSidebar(true)}>
                  <IoMenu size={30} className="text-black" />
                </button>
              </div>
            )}

            {/* Desktop Menu */}
            {isLargeScreen && (
              <nav className="hidden md:flex flex-col md:flex-row" key="nav">
                <Link
                  to="/"
                  className="mx-4 mb-2 md:mb-0 font-body font-semibold hover:text-[#2DBC78] mt-2"
                  style={{
                    fontFamily: "Roboto, sans-serif",
                    textDecoration: "none",
                  }}
                >
                  Home
                </Link>
                <Link
                  to="/privacy-policy"
                  className="mx-4 mb-2 md:mb-0 font-body font-semibold hover:text-[#2DBC78] mt-2"
                  style={{
                    fontFamily: "Roboto, sans-serif",
                    textDecoration: "none",
                  }}
                >
                  Privacy Policy
                </Link>
              </nav>
            )}
          </div>
        </header>

        {/* Mobile Sidebar Menu */}
        {showSidebar && (
          <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 z-50">
            <div
              ref={sidebarRef}
              className="fixed top-0 right-0 h-full bg-white shadow-lg p-4"
              style={{ width: "300px" }}
            >
              <button
                onClick={() => setShowSidebar(false)}
                className="absolute top-4 right-4"
              >
                <IoClose size={30} className="text-black" />
              </button>
              <nav className="flex flex-col space-y-4 mt-10">
                <Link
                  to="/"
                  className="text-lg font-semibold hover:text-[#128d8d] text-left border-b border-gray-300 pb-2"
                  onClick={() => setShowSidebar(false)}
                >
                  Home
                </Link>
                <Link
                  to="/privacy-policy"
                  className="text-lg font-semibold hover:text-[#128d8d] text-left border-b border-gray-300 pb-2"
                  onClick={() => setShowSidebar(false)}
                >
                  Privacy Policy
                </Link>
              </nav>
            </div>
          </div>
        )}
      </div>
      <div className="privacy-policy-container mx-auto lg:px-[72px] xl:px-[190px] 2xl:px-[270px] bg-[#ffffff]">
        <div className="w-full h-auto flex justify-center items-center pt-20 md:pt-0">
          <div className="container mx-auto px-2 py-8 text-justify text-[15px]">
            <h1 className="text-4xl font-extrabold text-center mb-3">
              Privacy Policy
            </h1>
            <br />
            <div className="md:text-[15px]">
              <p>
                Our Privacy Policy assists you in knowing our data practices and
                the information we process to offer our services to the users.
                This Privacy Policy elaborates on the information we collect and
                its effect on you. It also explains the steps we take to secure
                your privacy, like creating our services so delivered messages
                aren't saved by us and offering you command over who you talk to
                with our services. This Privacy Policy applies to all services
                offered by the Quick Chat app. Please read the Terms and Privacy
                Policy carefully before using the Quick Chat app.
              </p>
            </div>
            {/* Contact Information */}
            <div className="mt-8">
              <h2 className="text-xl font-semibold mb-4">Terms of use</h2>
              <p>
                To use the app, the sender and receiver should be Quick Chat
                users.
              </p>
              <p>
                To start the Chat, you should add a contact to your list and
                send the request; initiating the Chat is an essential job.
                <br /> You can also invite others to use our app
              </p>
              <p>
                Users can send messages, images, text etc., to other Quick Chat
                users.
              </p>
            </div>
            <div className="mt-8">
              <h2 className="text-xl font-semibold mb-4">
                Information We Collect
              </h2>
              <p>
                Quick Chat collects or receives certain information. To
                understand, customize, operate, improve, provide, market, and
                support our services, incorporating when you install or use our
                Services. We receive and collect different kinds of information
                depending on how you use our Services. We need specific
                information to perform our services, and we cannot do so without
                it. For instance, you must register using your mobile phone
                number or email address to access our Services.
              </p>
              <br />
              <p>
                If you choose to use certain optional features of our services,
                we will need to collect more information from you to deliver
                those benefits. As necessary, you will be informed of such a
                collection. You won't be able to use a feature if you decide not
                to provide the required information. Android smart phones, the
                Settings menu allow you to control permissions.
              </p>
            </div>
            <div className="mt-8">
              <h2 className="text-xl font-semibold mb-4">
                Information You Provide
              </h2>
              <p>
                You should provide your basic information and mobile number or
                email address to create your Quick Chat account. Without this
                information, you cannot create your account on our app. You can
                add other essential information, like about and profile
                pictures, to your account.
              </p>
              <br />
              <p>
                You’re Connections. Suppose applicable regulations allow you to
                use the contact upload option to give us regular access to the
                phone numbers in your address book, including those of other
                contacts and users of our Services. We'll handle this
                information for you in a way that makes sure any of your
                contacts who aren't yet using our Services can't be identified
                by us. Users can easily join, create or get added to lists and
                groups, which are linked to your account's information. You can
                add a group description or profile image
              </p>
            </div>
            <div className="mt-8">
              <h2 className="text-xl font-semibold mb-4">
                Managing, Retaining, and Updating Your Information
              </h2>
              <p>
                We retain information for as long as required to fulfill the
                purposes outlined in this Privacy Policy, including those
                associated with providing our Services and other legal purposes,
                preventing and enforcing violations of our Terms, or defending
                our users, property, and rights. The time that data is stored
                varies depending on the data type, why it is being processed and
                collected, any applicable operational or legal retention
                requirements, and any applicable legal duties.
              </p>
              <br />
              <p>
                You can use the following tools to further handle, update or
                remove your information:
              </p>
              <p>
                services settings. If required, you can handle the definite
                information accessible to other users. You can also use a block
                feature to restrict another user with whom you communicate.
              </p>
            </div>
            <div className="mt-8">
              <h2 className="text-xl font-semibold mb-4">
                How We Use Information
              </h2>
              <p>
                We utilize your information to provide, operate, improve, and
                troubleshoot activities. We customize our services. We provide
                our services and use your information to understand the new
                needs of the app users. We often conduct troubleshooting
                activities to find out the issues and resolve the errors.
              </p>
            </div>
            <div className="mt-8">
              <h2 className="text-xl font-semibold mb-4">
                Law, Protection and Our Rights
              </h2>
              <p>
                We collect, share, and access your information as mentioned in
                our Privacy Policy above if we have trust that is required to:
                <br />
                (a) address fraud, prevent, investigate, or detect other
                security, technical issues or illegal activity <br /> (b) compel
                our terms or use and other required terms and policies,
                incorporating for analysis of potential violations <br /> reply
                according to applied regulations or law.
              </p>
            </div>
            foo
            <div className="mt-8">
              <h2 className="text-xl font-semibold mb-4">
                Updates to Our Policy
              </h2>
              <p>
                We may update the privacy policy at any time, whenever required.
                Before updating the policy, we'll notify you of amendments. You
                should often review our Privacy Policy.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-[#12AD63]">
        <Footer />
      </div>
    </>
  );
};

export default PrivacyPolicy;
